var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1728_22026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.15865 0 0 5.15865 0 11.5C0 17.8414 5.15865 23 11.5 23C17.8414 23 23 17.8414 23 11.5C23 5.15865 17.8414 0 11.5 0Z",
    fill: "#479BD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3275 9.06192L11.0983 15.291C10.9114 15.4779 10.6661 15.5719 10.4208 15.5719C10.1755 15.5719 9.93018 15.4779 9.74329 15.291L6.62877 12.1764C6.25395 11.8018 6.25395 11.1961 6.62877 10.8214C7.00341 10.4466 7.60898 10.4466 7.9838 10.8214L10.4208 13.2584L15.9725 7.70689C16.3472 7.33208 16.9527 7.33208 17.3275 7.70689C17.7022 8.08154 17.7022 8.6871 17.3275 9.06192Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1728_22026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blue-tick.aada282e0a5586ede608d08d5bfc0d92.svg";
export { ForwardRef as ReactComponent };